<template>
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>粉丝列表</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click='lookMore'>查看更多</el-button>
        </div>
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column prop="name" label="抖音账号称呼"></el-table-column>
            <el-table-column label="性别">
                <template slot-scope='scope'>
                    <span>{{dyCheckInfo.sex[scope.row.sex]}}</span>
                </template>
            </el-table-column>
            <el-table-column label="头像">
                <template slot-scope='scope'>
                    <img style='width: 50px; height: 50px;' :src='scope.row.avatar' alt='avatar' />
                </template>
            </el-table-column>
            <el-table-column prop="province" label="所属省"></el-table-column>
            <el-table-column prop="city" label="所属市"></el-table-column>
            <el-table-column prop="country" label="注册国家"></el-table-column>
        </el-table>
        <div style='padding-top: 10px; text-align: center;'>
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="page.page"
                :page-size="page.pageSize"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </el-card>
</template>

<script>
import { dyCheckInfo } from '../../../config'

export default {
    props: {
        infoData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            dyCheckInfo,
            page: {
                page: 1,
                pageSize: 5,
            }
        }
    },
    computed: {
        info() {
            return this.infoData
        },
        total() {
            let fansList = this.infoData.fans_list || [];
            return fansList.length
        },
        tableData() {
            let fansList = this.infoData.fans_list || [];
            return fansList.slice((this.page.page-1)*this.page.pageSize, this.page.page*this.page.pageSize)
        }
    },
    methods: {
        lookMore() {
            this.$emit('lookMore', null)
        },

        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page.page = val;
        },
    }
}
</script>

<style scoped>

</style>
